import { AnalyticsTranslationKeys } from 'intl/keys';
import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { useCallback, useMemo } from 'react';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from '../common/hooks';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useRootCause(): IssueChartContext {
  const processesWithRootCause = useProcessesWithField(
    IssueFieldNames.rootCauses
  );
  const access = useCallback(() => {
    return Boolean(processesWithRootCause.length);
  }, [processesWithRootCause]);
  const filters = useIssueChartFilters({ chart: IssueChart.rootCause, processes: processesWithRootCause });
  const additionalParams = useMemo(
    () => ({
      visibleProcesses: processesWithRootCause.map(
        (process) => process._id
      ),
    }),
    [processesWithRootCause]
  );
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.rootCause, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.rootCauseChart,
    chartType: ChartType.donut,
    canAccess: access,
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
